import React from "react";
import { useEffect, useState } from "react";
import { Tab, Tabs } from "@material-ui/core";
import { clone, get } from "lodash";

import Button from "components/CustomButtons/Button";
import CustomDialogWithInput from "components/CustomDialog/CustomDialogWithInput";

import InvoiceElement from "./InvoiceElement";
import InvoiceFormWizard from "./InvoiceFormWizard";
import InvoiceFullForm from "./InvoiceFullForm";
import { invoiceFields } from "./InvoiceModel";
import { defaultData, INVOICE_STATUS } from "./InvoiceObj";
import { generateInvoiceHTML2 } from "./InvoiceHTML";
import InvoicePdfModal from "./InvoicePdfModal";
import { getUser } from "../../shared/authValidation";
import { cloneJ, handleError } from "../../shared/utility";
import { calculateTotalInvoicePicture, getInvoiceFullData } from "./InvoiceLogic";
import axios from 'store/axios/axios-invoice';
import { approveInvoices } from "../RSheets/RSheetsLogic";
import NotificationAsk from "../../components/Notification/NotificationAsk";

const InvoiceForm = (props) => {
    const {
        action,
        closeForm,
        createInvoiceEntry,
        updateInvoiceEntry,
        getInvoicePdf,
        parentData,
        pdfData,
        getRsheet,
        rsheetData,
        clearRSheets,
        getInvoiceEntries,
        listStatus,
        clearInvoicePdfData,
        invoicePayments,
        success,
        error
    } = props;

    const [tab, setTab] = useState("wizard");

    const [openedDataModal, setOpenedDataModal] = useState(false);
    const [fieldToEdit, setFieldToEdit] = useState(null);

    const [formData, setFormData] = useState(defaultData);
    const [routingSheet, setRoutingSheet] = useState(null);

    const [openedPdfView, setOpenedPdfView] = useState(false);
    const [localPdfData, setLocalPdfData] = useState(null);
    const [askVoid, setAskVoid] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);

    const user = getUser();
    const userInvoicePerms = Object.keys(user.permObj).filter(up => {
        if (up.indexOf('Invoice ') !== -1) {
            return true;
        }
    }).map(u => {
        const arr = u.split('Invoice ');
        if (arr[1]) {
            return arr[1];
        }
    });

    const openPdfView = () => setOpenedPdfView(true);
    const closePdfView = () => setOpenedPdfView(false);

    const handleOpenPdfView = async (data, parentData, rsheetData) => {
        console.log('generating invoice html from InvoiceForm.js', data, parentData, rsheetData);
        const invo_data = await calculateTotalInvoicePicture(parentData.rs_id);
        const html = generateInvoiceHTML2(invo_data, parentData.id);
        getInvoicePdf({ htmlTemplate: html });
        openPdfView(true);
    };

    const rsId = get(routingSheet, "id", null);

    useEffect(() => {
        return () => {
            clearRSheets()
            getInvoiceEntries(listStatus);
        }
    }, [])

    useEffect(() => {
        if (pdfData && typeof pdfData === "string") {
            const parsedPdf = JSON.parse(pdfData);
            setLocalPdfData(parsedPdf);
            clearInvoicePdfData();
        }
    }, [pdfData]);

    useEffect(() => {
        if (action === 'Add') {
            if (rsId) {
                getRsheet(rsId);
            }
        }
        if (action === 'Edit') {
            if (rsId) {
                getRsheet(rsId);
            } else if (parentData && parentData.rs_id) {
                getRsheet(parentData.rs_id);
            }
        }
    }, [rsId, parentData]);

    useEffect(() => {
        if (rsheetData) {

            // NOTE : This is resetting the invoice data - seems to be only suited for New Invoices
            // ------
            // const newInvoiceForm = clone(formData);
            // const rsData = get(rsheetData, 'json_data', {});
            // newInvoiceForm.rsData = rsData;
            // newInvoiceForm.title = `Generated from RS illi# ${get(
            //     rsData,
            //     "illi_number",
            //     ""
            // )}`;

            // if (rsheetData.title) {
            //     const extraTitle = ` - Rev ${rsheetData.title.split('_').length}`
            //     newInvoiceForm.title = newInvoiceForm.title + extraTitle
            // }

            // newInvoiceForm.illi = get(rsData, "illi_number", "").toString();
            // newInvoiceForm.rs_id = get(rsheetData, 'id');

            setRoutingSheet(rsheetData)
        }
    }, [rsheetData]);

    const [allowToSubmit, setAllowToSubmit] = useState(false);

    const canViewPdf = parentData && parentData.status !== INVOICE_STATUS.DRAFT;

    useEffect(() => {
        if (parentData && action !== "Add") {
            const newFormData = clone(parentData.data);
            newFormData.rsType = rsheetData ? rsheetData.type : null;
            setFormData(newFormData);
        }
    }, [parentData, rsheetData]);

    const openDataModal = (field) => {
        setOpenedDataModal(true);
        setFieldToEdit(field);
    };
    const closeDataModal = () => {
        setOpenedDataModal(false);
        setFieldToEdit(null);
    };

    const getTabIndex = () => {
        if (tab === "wizard") return 0;
        if (tab === "full") return 1;
    };

    const updateDataObj = (field, val) => {
        const newData = clone(formData);
        newData[field] = val;
        setFormData(newData);
    };

    const handleSubmit = (status) => {
        let s = status;
        if (!allowToSubmit) {
            s = 0;
        }
        createInvoiceEntry({
            status: s,
            data: formData,
        });
    };

    const handleUpdate = (changes) => {
        const newData = { ...clone(parentData), ...changes };
        console.log('newData ?', newData);
        updateInvoiceEntry(newData);
    };

    useEffect(() => {
        if (isUpdating && success === 'Successfully updated invoice') {
            closeForm();
            setIsUpdating(false);
        }
    }, [success]);

    console.log('InvoiceForm', props, formData, userInvoicePerms, user);

    const invoice_dat = props.parentData ? props.parentData : {};

    console.log('Invoice DAT', invoice_dat);

    return (
        <div>
            <h2>
                {action === "Edit" ? (
                    <div>
                        Edit Invoice <strong>{parentData.title}</strong>
                    </div>
                ) : (
                    "Add Invoice"
                )}
            </h2>

            {props.action !== "View" && (
                <div>
                    <Tabs
                        TabIndicatorProps={{
                            style: {
                                background: "#da3b2f",
                                borderBottom: "1px solid #da3b2f",
                                color: "#da3b2f",
                            },
                        }}
                        style={{ marginBottom: 10 }}
                        value={getTabIndex()}
                    >
                        {
                            <Tab
                                onClick={() => {
                                    setTab("wizard");
                                }}
                                style={{
                                    color:
                                        getTabIndex() === 0
                                            ? "#da3b2f"
                                            : "rgba(0, 0, 0, 0.87)",
                                }}
                                tabIndex={0}
                                label="Invoice Wizard"
                                icon={<i className="fas fa-magic font-22"></i>}
                            />
                        }
                        {
                            <Tab
                                onClick={() => {
                                    setTab("full");
                                }}
                                style={{
                                    color:
                                        getTabIndex() === 1
                                            ? "#da3b2f"
                                            : "rgba(0, 0, 0, 0.87)",
                                }}
                                tabIndex={1}
                                label="Full Form"
                                icon={
                                    <i className="fas fa-newspaper font-22"></i>
                                }
                            />
                        }
                    </Tabs>
                </div>
            )}
            {tab === "wizard" && (
                <InvoiceFormWizard
                    action={action}
                    fieldModels={invoiceFields}
                    formData={formData}
                    setAllowToSubmit={setAllowToSubmit}
                    setFormData={setFormData}
                    setTab={setTab}
                    updateDataObj={updateDataObj}
                    routingSheet={routingSheet}
                    setRoutingSheet={setRoutingSheet}
                    closeForm={closeForm}
                    permissions={props.permissions}
                    rsheetData={props.rsheetData}
                    parentData={props.parentData}
                    setParentData={props.setParentData}
                />
            )}
            {tab === "full" && (
                <InvoiceFullForm
                    fieldModels={invoiceFields}
                    formData={formData}
                    openDataModal={openDataModal}
                    closeForm={closeForm}
                    permissions={props.permissions}
                    parentData={props.parentData}
                    invoicePayments={props.invoicePayments}
                    rsheetData={props.rsheetData}
                />
            )}

            <div className="bottom-dweller">
                {(action === "Add" || props.action === "Edit") && (
                    <React.Fragment>
                        {/* <Button
                            color="white"
                            className="mr-20"
                            onClick={() => {
                                if (action === "Add") {
                                    handleSubmit(INVOICE_STATUS.DRAFT);
                                } else if (action === "Edit") {
                                    handleUpdate({
                                        data: formData,
                                    });
                                }
                                closeForm();
                            }}
                            style={{ marginTop: 10 }}
                        >
                            <i className="fas fa-save"></i> Save Invoice Draft
                        </Button> */}
                        {userInvoicePerms.indexOf('approve') !== -1 && props.tab !== INVOICE_STATUS.APPROVED && <Button
                            color="danger"
                            className="mr-20"
                            onClick={async () => {
                                if (action === "Add") {
                                    handleSubmit(INVOICE_STATUS.APPROVED);
                                } else if (action === "Edit") {
                                    console.log('approving...', props, formData);
                                    const invoice_id = props.parentData?.id;
                                    const rs_id = props.parentData?.rs_id;
                                    const approved = await approveInvoices(rs_id, invoice_id, formData);
                                    if (approved) {
                                        closeForm();
                                    } else {
                                        alert('Something happened, invoice not yet approved. If the issue persists please call tech support.')
                                    }
                                }
                            }}
                            style={{ marginTop: 10 }}
                        >
                            <i className="fas fa-save"></i> Approve Invoice
                        </Button>}

                        {userInvoicePerms.indexOf('void') !== -1 && props.tab === INVOICE_STATUS.APPROVED && <Button
                            color="white"
                            className="mr-20"
                            onClick={async () => {
                                const rs_id = props.parentData?.rs_id;
                                const invoice_id = props.parentData?.id;
                                if (rs_id) {
                                    const invo_dat = await calculateTotalInvoicePicture(rs_id);
                                    let found_a_payment = false;
                                    if (invo_dat) {
                                        if (invo_dat.invoices) {
                                            invo_dat.invoices.forEach(inv => {
                                                if (inv.id === invoice_id) {
                                                    if (inv.payments.length > 0) {
                                                        found_a_payment = true;
                                                    }
                                                }
                                            })
                                        }
                                    }
                                    if (!found_a_payment) {
                                        if (invoice_id) setAskVoid(invoice_id);
                                    } else {
                                        alert('All payments need to be voided in order to void this invoice.')
                                    }
                                }
                            }}
                            style={{ marginTop: 10 }}
                        >
                            Void
                        </Button>}

                        {(userInvoicePerms.indexOf('edit') !== -1 && userInvoicePerms.indexOf('approve') === -1) && <Button
                            color="danger"
                            className="mr-20"
                            onClick={() => {
                                if (action === "Add") {
                                    handleSubmit(INVOICE_STATUS.PENDING);
                                } else if (action === "Edit") {
                                    const updateObj = {
                                        status: INVOICE_STATUS.PENDING,
                                        data: formData
                                    };
                                    handleUpdate(updateObj);
                                    setIsUpdating(true);
                                }
                            }}
                            style={{ marginTop: 10 }}
                        >
                            <i className="fas fa-save"></i> Submit Invoice
                        </Button>}

                        <Button
                            color="white"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                                console.log('opening pdf', formData, props);
                                console.log('opening pdf __', formData);
                                const data = props.parentData;
                                const rsInvoiceData = getInvoiceFullData(data);
                                handleOpenPdfView(rsInvoiceData, data);
                            }}
                        >
                            VIEW PDF
                        </Button>

                        {(user.mail === "dev@sap-developers.com" || user.mail === "support@illicre.com") && 
                            invoice_dat.status === INVOICE_STATUS.APPROVED
                        && <Button
                            color="success"
                            style={{ marginRight: 20 }}
                            onClick={async () => {
                                try {
                                    await axios.put('/entry', {
                                        id: invoice_dat.id,
                                        status: INVOICE_STATUS.PENDING
                                    })
                                    alert('Invoice set to pending');
                                    window.location.reload();
                                } catch(e) {
                                    handleError(e);
                                    alert('Error putting back to pending')
                                }
                            }}
                        >
                            SET BACK TO PENDING
                        </Button>}
                    </React.Fragment>
                )}
            </div>

            <CustomDialogWithInput
                element={InvoiceElement}
                open={openedDataModal}
                close={closeDataModal}
                fieldModels={invoiceFields}
                formData={formData}
                setFormData={setFormData}
                field={fieldToEdit}
                updateDataObj={updateDataObj}
            />

            {localPdfData && openedPdfView && (
                <InvoicePdfModal
                    pdfData={localPdfData}
                    invoice={formData}
                    open={true}
                    close={() => {
                        setLocalPdfData(null);
                        closePdfView();
                    }}
                />
            )}

            {askVoid && <NotificationAsk 
                open={true}
                close={() => {
                    setAskVoid(null);
                }}
                success={async () => {
                    try {
                        await axios.put('/entry', {
                            id: askVoid, 
                            status: INVOICE_STATUS.VOIDED,
                            is_void: true
                        })
                        closeForm();
                    } catch(e) {
                        alert('Could not void the invoice, please contact tech support.');
                        handleError(e);
                    }
                }}
                title="Are you sure?"
                message="Are you sure you want to void this invoice?"
            />}
        </div>
    );
};

export default InvoiceForm;
